<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i>  {{ $t('page.title.white_label') }}
      <template v-slot:right>
        <b-button @click="openModal('create')" size="sm" variant="success">  {{ $t('btn.white_label.create') }}</b-button>
      </template>
    </page-header>
    <CreateModal ref="create-modal"></CreateModal>
    <page-card>
      <template v-slot:header>
        {{ $t('title.list') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>

          <div class="table-responsive">
            <b-table striped
                     :empty-text="$t('table.no_results')"
                     :busy="isBusy"
                     hover
                     head-variant="dark"
                     outlined
                     :sort-by.sync="orderColumn"
                     :sort-desc.sync="orderDirection"
                     :no-local-sorting="true"
                     :items="items"
                     :fields="fields">

              <template #cell(id)="data">
                {{ data.item.id.uuid | shortId }}
              </template>

              <template #cell(createdAt)="data">
                {{ data.value | dateFormat('YYYY-MM-DD HH:mm:ss') }}
              </template>

              <template #cell(image)="data">
                <img style="width: auto; max-height: 30px;" :src="data.item.image" alt="">
              </template>

              <template #cell(active)="data">
                <b-badge v-if="data.item.active" pill variant="success">{{ $t('table.white_label.active') }}</b-badge>
                <b-badge v-if="!data.item.active" pill variant="danger">{{ $t('table.white_label.inactive') }}</b-badge>
              </template>

              <template #cell(actions)="data">
                <div class="table-action--cell">
                  <b-button variant="primary" size="sm" @click="openModal('show', data.item)">{{$t('table.btn.white_label_edit_and_details')}}</b-button>
                  <b-button v-if="!data.item.active" variant="success" size="sm" @click="activateOrDeactivate(data.item)">{{$t('table.btn.white_label_activate')}}</b-button>
                  <b-button v-if="data.item.active" variant="danger" size="sm" @click="activateOrDeactivate(data.item, 'deactivate')">{{$t('table.btn.white_label_deactivate')}}</b-button>
                </div>
              </template>

              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>{{$t('state.loading')}}</strong>
                </div>
              </template>
            </b-table>
          </div>

          <grid-pagination :total-count="totalCount"
                           :per-page="perPage"
                           :current-page="currentPage"
                           @load-items="paginationReload"></grid-pagination>

        </div>
      </template>
      <template v-slot:footer>

      </template>
    </page-card>
  </div>
</template>


<script>
// import Vue from "vue";
import axios from 'axios';
import CreateModal from "./components/CreateModal";
// import ShowModal from "./components/ShowModal";
import GridMixin from '../../components/grid/GridMixin';
import GridPagination from "../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";

export default {
  mixins: [GridMixin],
  components: {
    PageCard,
    PageHeader,
    GridPagination,
    CreateModal
  },
  data() {
    return {
      gridGetUrl: '/api/tenant/tenant/list',
      // orderColumn: 'name',
      orderDirection: false,
      fields: [
        {key: 'id', sortable: false, label: this.$t('table.header.id')},
        {key: 'name', sortable: false, label: this.$t('table.header.white_label.name')},
        {key: 'frontUrl', sortable: false, label: this.$t('table.header.white_label.front_url')},
        {key: 'backUrl', sortable: false, label: this.$t('table.header.white_label.back_url')},
        {key: 'image', sortable: false, label: this.$t('table.header.white_label.image')},
        {key: 'active', sortable: false, label: this.$t('table.header.white_label.active')},
        {key: 'createdAt', sortable: false, label: this.$t('table.header.white_label.created_at')},
        {key: 'actions', label: this.$t('table.header.actions'), sortable: false}
      ],
      createModalInstance: null,
      showModalInstance: null,
    };
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    activateOrDeactivate(item, type = 'activate') {
      const title = type === 'activate' ? this.$t('white_label.activate.title') : this.$t('white_label.deactivate.title');
      const label = type === 'activate' ? this.$t('white_label.activate.are_you_sure') : this.$t('white_label.deactivate.are_you_sure');

      this.$bvModal.msgBoxConfirm(`${title}: ${item.name}`, {
        title: label,
        okTitle: this.$t('btn.white_label_submit'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'success',
      })
      .then(value => {
        if (value) {
          axios.post(`/api/tenant/tenant/${type}/${item.id.uuid}`)
            .then(() => {
              this.loadItems();
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    showItem(data) {
      this.openModal('show');
      this.showModalInstance.setData(data);
    },
    openModal(modalName, tenant) {
      console.log('tenant',tenant)
      if(tenant) {
        this.$refs['create-modal'].showModal(tenant);
      } else {
        this.$refs['create-modal'].showModal();
      }

      // let ModalConstructor;

      // switch(modalName){
      //   case('create'): {
      //     if(!this.createModalInstance){
      //       ModalConstructor = Vue.extend(CreateModal)
      //       this.createModalInstance = new ModalConstructor({parent: this});
      //       this.createModalInstance.$mount();
      //     } else {
      //       this.createModalInstance.showModal();
      //     }
      //     break;
      //   }
      //   case('show'): {
      //     if(!this.showModalInstance){
      //       ModalConstructor = Vue.extend(CreateModal);
      //       this.showModalInstance = new ModalConstructor({parent: this, propsData: { tenant }});
      //       this.showModalInstance.$mount();
      //     } else {
      //       this.showModalInstance.showModal();
      //     }
      //     break;
      //   }
      // }
    }
  }
}
</script>
